import React, { useReducer } from 'react';
import Header from '../shared/components/Header/index';
import Routes from '../Routes';
import Drawer from '../shared/components/Drawer/index';
import AppContext from '../shared/contexts/AppContext';
import { Box, Container, Link, Typography } from '@material-ui/core';
import { initialState, reducer } from '../shared/reducers';

function App() {
	const [state, dispatch] = useReducer(reducer, initialState);

	return (
		<AppContext.Provider value={{ state, dispatch }}>
			<div className='App'>
				<Container maxWidth='md'>
					<Drawer />
					<Header />
					<Routes />
				</Container>
				<Box style={{ position: 'absolute', right: 40, bottom: 20 }}>
					<Typography variant='body2' gutterBottom>
						Sample Merchant by{' '}
						<Link
							href='https://www.xpay.world/'
							target='_blank'
							rel='noreferrer'
							style={{
								fontWeight: 700,
								color: '#000000',
								textDecoration: 'none',
							}}
						>
							XPay
						</Link>
					</Typography>
				</Box>
			</div>
		</AppContext.Provider>
	);
}

export default App;
